export namespace IQuickAdd {
  export namespace IQuickAddOption {
    /**
     * Return an instance of IQuickAddOption with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IQuickAddOption>
    ): IQuickAddOption =>
      ({
        ...(partial ?? {}),
      }) as IQuickAddOption;
  }

  /**
   * Data needed for quickly adding a product option to the cart,
   * populated iff a product option can be quickly added without additional dialog.
   * This is currently the case if the product has a single option and no customizations.
   */
  export interface IQuickAddOption {
    /**
     * @protobufOption (.faire.common.tokenType) = PRODUCT_OPTION
     */
    option_token: string | undefined;
    option_unit_multiplier: number | undefined;
    option_min_order_quantity: number | undefined;
    option_available_units: number | undefined;
  }

  /**
   * Return an instance of IQuickAdd with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IQuickAdd>): IQuickAdd =>
    ({
      ...(partial ?? {}),
    }) as IQuickAdd;
}

/**
 * Data for powering QuickAdd UI element which allows retailers to quickly
 * add to cart from search / brand page.
 */
export interface IQuickAdd {
  /**
   * The text that should be shown in the quick add button (e.g., "+ Quick Add Case").
   */
  quick_add_text: string | undefined;
  quick_add_option: IQuickAdd.IQuickAddOption | undefined;
  /**
   * The text that should be shown in the Mobile quick add feature (e.g., "Case of 6").
   */
  mobile_quick_add_text: string | undefined;
}
